import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE, withCredentials: true, headers: { "Content-Type": "application/json" } });

api.interceptors.response.use(
  (r) => r,
  (error) => {
    const detail = error?.response?.data?.detail;
    let message = "Request failed";
    if (typeof detail === "string") message = detail;
    else if (Array.isArray(detail)) message = detail.map((d) => `${(d.loc || []).slice(-1)[0]}: ${d.msg}`).join("; ");
    else if (detail && typeof detail === "object" && detail.message) message = detail.message;
    else if (error?.message) message = error.message;
    error.userMessage = message;
    error.status = error?.response?.status;
    error.code = detail && typeof detail === "object" ? detail.code : undefined;
    if ((error.code === "mfa_enrolment_required" || error.code === "password_change_required") && window.location.pathname !== "/security/setup") {
      window.location.assign("/security/setup");
    }
    return Promise.reject(error);
  }
);

export const errMsg = (e) => e?.userMessage || e?.message || "Something went wrong";
